import { useForm } from 'react-hook-form'
// @ts-nocheck
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { resetPassword } from '../api/auth'
import { useEffect, useState } from 'react'
import { useToast } from '@shared/toast/ToastProvider'
import { FormField } from '@shared/ui/FormField'
import { Input } from '@shared/ui/Input'
import { Button } from '@shared/ui/Button'
import { CodeInput6 } from '@shared/ui/CodeInput6'
import { http } from '@shared/libs/http'

const schema = z.object({
  email: z.string().email(),
  code: z.string().length(6),
  new_password: z.string().min(10)
})
type FormValues = z.infer<typeof schema>

export function ResetPasswordPage() {
  const [msg, setMsg] = useState<string | null>(null)
  const [err, setErr] = useState<string | null>(null)
  const { register, handleSubmit, formState } = useForm<FormValues>({ resolver: zodResolver(schema) })
  const { push } = useToast()

  // Prime CSRF cookie for POSTs
  useEffect(() => {
    http.get('/auth/session').catch(() => {})
  }, [])

  const onSubmit = async (v: FormValues) => {
    setErr(null)
    try {
      await resetPassword(v)
      setMsg('Password reset. You can now sign in.')
    } catch (e: any) {
      const m = e?.response?.data?.detail ?? 'Reset failed'
      setErr(m)
      push({ type: 'error', title: 'Reset failed', description: m })
    }
  }

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="w-full max-w-sm bg-white rounded-lg shadow p-6">
        <h1 className="text-xl font-semibold mb-4">Reset password</h1>
        {msg && <div className="mb-2 text-sm text-success">{msg}</div>}
        {err && <div className="mb-2 text-sm text-danger">{err}</div>}
        <form className="grid gap-3" noValidate onSubmit={handleSubmit(onSubmit)}>
          <FormField label="Email" message={formState.errors.email?.message}>
            <Input type="email" {...register('email')} />
          </FormField>
          <FormField label="Code" message={formState.errors.code?.message}>
            <CodeInput6 {...register('code')} />
          </FormField>
          <FormField label="New password" message={formState.errors.new_password?.message}>
            <Input type="password" {...register('new_password')} />
          </FormField>
          <Button disabled={formState.isSubmitting}>Reset password</Button>
        </form>
      </div>
    </div>
  )
}
 
// @ts-nocheck
